const placeholderImg = `data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmZmIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICA8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIxIj4KICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIKICAgICAgICAgICAgICAgIGJlZ2luPSIwcyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAyMCIKICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDsgMSIKICAgICAgICAgICAgICAgIGtleVNwbGluZXM9IjAuMTY1LCAwLjg0LCAwLjQ0LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IgogICAgICAgICAgICAgICAgYmVnaW49IjBzIiBkdXI9IjEuOHMiCiAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7IDAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjMsIDAuNjEsIDAuMzU1LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgPC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMSI+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiCiAgICAgICAgICAgICAgICBiZWdpbj0iLTAuOXMiIGR1cj0iMS44cyIKICAgICAgICAgICAgICAgIHZhbHVlcz0iMTsgMjAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjE2NSwgMC44NCwgMC40NCwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIKICAgICAgICAgICAgICAgIGJlZ2luPSItMC45cyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAwIgogICAgICAgICAgICAgICAgY2FsY01vZGU9InNwbGluZSIKICAgICAgICAgICAgICAgIGtleVRpbWVzPSIwOyAxIgogICAgICAgICAgICAgICAga2V5U3BsaW5lcz0iMC4zLCAwLjYxLCAwLjM1NSwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgIDwvY2lyY2xlPgogICAgPC9nPgo8L3N2Zz4=`;

// Ticket SUPPORT-3116
// 預設的超連結文字顏色 (藍色) 會把編輯設定的顏色蓋掉
// .font-loaded * 會在設定字型並且又設定粗體之類的樣式，覆蓋掉字型設定，因為他會吃到 .font-loaded * 的 font-family 設定
const fontColorAndFontFamilyInheritStyle = `
    & span[style~="color:"] a {
        color: inherit;
    }
    & span[style~="font-family:"] * {
        fontFamily: inherit;
    }
`;

export const textboxStyle = `
    margin-top: 0;
    margin-bottom: 0;
    word-wrap: break-word;
    letter-spacing: 0.5px;
    & a { text-decoration: none; }
    & iframe { max-width: 100%; }
    & img {
        max-width: 100%;
        width: auto;
        height: auto !important;
        object-fit: fill;
        animation: none;
        vertical-align: top;
        padding:0;
    }
    & blockquote {       
        margin: 30px 0;
        margin-left: 18px;
        border-left: 4px solid;
        padding-left: 1.12rem;
        font-size: 1rem;
        line-height: 1.5;
        color:#5E35B1;
    }
    @media(max-width: 480px) {
        & blockquote {
            margin: 10px;
        }
    }
    & hr {
        width:100%;
    }
    ${fontColorAndFontFamilyInheritStyle}`;

export const basicToolbarStyle = ({ zIndex = 30, width = '940px' } = {}) => `
    width: 100%;

    .fr-toolbar.fr-top {
        position: fixed;
        transform: translateY(-100%);
        z-index: ${zIndex} !important;
        width: ${width} !important;
        -webkit-box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 1px 1px rgba(0, 0, 0, 0.16);
        -moz-box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 1px 1px rgba(0, 0, 0, 0.16);
        box-shadow:
            0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 1px 1px rgba(0, 0, 0, 0.16);
    }
`;

export const viewerBasicStyle = `
    overflow: hidden; 
    width: 100%;
`;

export const froalaPaddingStyle = (isShowPadding = false) => `
    .fr-box.fr-box .fr-element {
        padding: ${isShowPadding ? '0 1rem' : '0'};
    }
    
    .fr-box.fr-basic .fr-element {
        padding:  ${isShowPadding ? '0 1rem' : '0'};
    }
`;

export const displayStyle = `
    ${textboxStyle}
    & a { text-decoration: none; }
    & iframe { max-width: 100%; vertical-align: top; }
    & img.lazyload {
        background: rgb(205, 205, 205) url('${placeholderImg}') no-repeat center;
    }
    `;
